import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import type { RootState } from "../../../../store/Index";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import CommentsTable from "./components/CommentsTable";
import BookingAndDeceasedDetails from "./components/BookingDeceasedDetails";
import TabButtons from "./components/TabButtons";
import { MemoryTableGallery } from "./components/MemoryTableGallery";
import { MemoryTableUpload } from "./components/MemoryTableUpload";
import { MemoryBookDelivery } from "./components/MemoryBookDelivery";
import { useParams } from "react-router-dom";
import apiService from "../../../../service/Api";
import { showErrorToast } from "../../../../components/common/ShowToast";

type activeTabType =
  | "tribute-comments"
  | "youtube-comments"
  | "media"
  | "upload"
  | "delivery";

const MemoryTableView2: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const reduxTheme = useSelector((state: RootState) => state.theme);
  const [activeTab, setActiveTab] = useState<activeTabType>("tribute-comments");
  const [commentsWaitingApproval, setCommentsWaitingApproval] =
    useState<number>(0);

  useEffect(() => {
    fetchApprovedComments();
  }, []);

  const fetchApprovedComments = async () => {
    try {
      const response = await apiService.get<{
        count: number;
      }>(
        `/api/chats/memorial-message/?stream_id=${id}&comment_source=generic&is_approved=false`
      );
      setCommentsWaitingApproval(response.data.count);
    } catch (error) {
      showErrorToast("Failed to fetch approved comments");
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -20 }}
      transition={{ duration: 0.3 }}
    >
      {/* Booking and deceased details */}
      <BookingAndDeceasedDetails />

      {/* Tab Nav */}

      <TabButtons
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        commentsWaitingApproval={commentsWaitingApproval}
      />

      {/* Active Tabs  */}

      <Box component={"section"} sx={{ mt: 1 }}>
        {activeTab === "tribute-comments" && (
          <Box
            sx={{
              backgroundColor: reduxTheme.primary_colors[900],
              p: 1,
              mt: 2,
              borderRadius: 3,
            }}
          >
            <CommentsTable
              commentsType={"tribute comments"}
              endpoint={`/api/chats/memorial-message/?stream_id=${id}&comment_source=generic`}
              fetchApprovedComments={fetchApprovedComments}
            />
          </Box>
        )}

        {/* wordpress | youtube | generic */}

        {activeTab === "youtube-comments" && (
          <Box
            sx={{
              backgroundColor: reduxTheme.primary_colors[900],
              p: 1,
              mt: 2,
              borderRadius: 3,
            }}
          >
            <CommentsTable
              commentsType={"youtube comments"}
              endpoint={`/api/chats/memorial-message/?stream_id=${id}&comment_source=youtube`}
              fetchApprovedComments={fetchApprovedComments}
            />
          </Box>
        )}

        {/* 
        
          /api/contacts/contact/ ====> post
          contact_source: "memory_page"
          contact_type: individual
          common component
        */}

        {activeTab === "media" && <MemoryTableGallery />}
        {activeTab === "upload" && <MemoryTableUpload />}
        {activeTab === "delivery" && (
          <MemoryBookDelivery setActiveTab={setActiveTab} />
        )}
      </Box>
    </motion.div>
  );
};

export default MemoryTableView2;
